export default __webpack_public_path__ + "static/media/BieniMedicoLogo.f0c72615.svg";